$(document).ready(function(){

	// // -- Hamburger --
	// $('.hamburger').on('click', function(){
	// 	$('body').toggleClass('mainMenu--open');
	// 	$(this).toggleClass('is-active');
	// });

	// -- Close mobile menu when click
	// $('.mainMenu li a:not(.dropdown-toggle)').on('click', function(){
	// 	$('body').removeClass('mainMenu--open');
	// 	$('.hamburger').removeClass('is-active');
	// });

	// -- Dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		e.preventDefault();		
		if (!$(this).parent('.dropdown').hasClass('open')) {
			$('.dropdown').removeClass('open');
			$(this).parent('.dropdown').toggleClass('open');
		} else {
			$('.dropdown').removeClass('open');
		}
	});

	// -- Close dropdown when click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.dropdown');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.dropdown').removeClass('open');
	  }
	});

	// -- Close dropdown on mouseleave --
	var closeDropdownMenu; // global
	$('.mainMenu').on('mouseleave', '.dropdown-menu', function(){
		closeDropdownMenu = setTimeout(function(){
			$('.dropdown').removeClass('open');
		},3000);
	});

	// -- Clear timeout to prevent close dropdown on mouseenter --
	$('.mainMenu').on('mouseenter', '.dropdown-menu', function(){
		clearTimeout(closeDropdownMenu);
	});

});



$(document).on('scroll resize orientationchange', function(){

	// -- Variables --
	var scrollTop = $(this).scrollTop();
	var header = $('.header').outerHeight();
	
	// -- Header fixed --
	if (scrollTop > header) {
		$('body').addClass('header--fixed');
	} else {
		$('body').removeClass('header--fixed');
	}

	// -- Webpage Type Laureats --
	if ($('body').hasClass('type--laureats')) {

		var webpageContentTop = $('.webpage__content').offset().top - header - 40;
		var webpageSidebarH = $('.webpage__sidebar .inner').outerHeight();
		var prefooterTop = webpageContentTop + $('.webpage__content').outerHeight();
		var prefooterTopWithoutSidebar = webpageContentTop + $('.webpage__content').outerHeight() - webpageSidebarH;
		var sidebarMenuItem = $('.webpage__sidebar .menu li');

		// -- Sticky sidebar --
		if (scrollTop < webpageContentTop) {
			// console.log('relative');
			$('body').removeClass('sidebar--fixed sidebar--locked');
		} else if ((scrollTop > webpageContentTop) && (scrollTop < prefooterTopWithoutSidebar)) {
			// console.log('fixed');
			$('body').removeClass('sidebar--locked').addClass('sidebar--fixed');
		} else {
			// console.log('locked');
			$('body').removeClass('sidebar--fixed').addClass('sidebar--locked');
		}

		// -- Sidebar Menu --
		var sectionsCount = $('.section').length;

		$('.webpage__content .section').each(function(key,value) {
			var sectionID = $(value).attr('id');
			var sectionOT = $(value).offset().top - header - 40;
			var sectionFirst = $('.section:first-child').offset().top - header - 40;
			var nextSectionOT;

			if (key === sectionsCount - 1) {
				nextSectionOT = prefooterTop;
			} else {
				nextSectionOT = $(value).next('.section').offset().top - header - 40;
			}
			
			if (scrollTop < sectionFirst) {
				sidebarMenuItem.removeClass('active');
			} else if ((scrollTop > sectionOT) && (scrollTop < nextSectionOT)) {
				sidebarMenuItem
				.removeClass('active')
				.find('a[href="#'+sectionID+'"]')
				.parent('li')
				.addClass('active');
			}
		});

	}
	
});
